import React, { useEffect, useRef } from 'react';
import useScript from './useScript';
import { useAppConfiguration, useTrackEvent } from '@wkda/funnel-components';
import trustpilotConfig from './config';
import trustpilotLeadConfig from './leadConfig';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const TrustPilot = _ref => {
  let {
    overrideConfig = {},
    type = '',
    screen = ''
  } = _ref;
  const trustBoxRef = useRef(null);
  const {
    locale
  } = useAppConfiguration();
  const leadConfig = trustpilotLeadConfig(locale, screen);
  const defaultConfig = trustpilotConfig(locale);
  const typeOfConfig = type === 'lead' ? leadConfig : defaultConfig;
  const config = {
    ...typeOfConfig,
    ...overrideConfig
  };
  useScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
  let trustpilotClassnames = [config.className];
  if (!config.clickable) {
    trustpilotClassnames.push('no-click');
  }
  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustBoxRef.current, true);
    }
  }, []);
  const track = useTrackEvent();
  const trackClickTrustpilot = () => {
    track({
      action: 'eventTracking',
      category: "" + (type ? type : 'handover'),
      eventData: {
        category: 'Trustpilot Ratings',
        action: 'Click',
        label: 'Trustpilot Ratings Section'
      }
    });
  };
  const overlayLink = config.href + "?utm_medium=trustbox&utm_source=MicroStar";
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "trustpilot-widget-wrapper",
      children: /*#__PURE__*/_jsx("div", {
        className: trustpilotClassnames.join(' '),
        "data-locale": config.locale,
        "data-template-id": config.templateId,
        "data-businessunit-id": config.businessUnitId,
        "data-style-height": config.height,
        "data-style-width": config.width,
        "data-theme": config.theme,
        "data-stars": config.stars,
        "data-tags": config.tags,
        ref: trustBoxRef,
        children: config.clickable && /*#__PURE__*/_jsx("a", {
          href: config.href,
          target: config.target,
          rel: config.rel,
          children: config.label
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "trustpilot-overlay",
      onClick: trackClickTrustpilot,
      children: /*#__PURE__*/_jsx("a", {
        href: overlayLink,
        target: config.target,
        rel: config.rel,
        className: "trustpilot-overlay",
        children: config.label
      })
    })]
  });
};
export default TrustPilot;